import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBan, faCopyright, faWifi } from '@fortawesome/free-solid-svg-icons';

import { NetworkStatusService, TenantService } from '@core/services';
import { TenantUtilities } from '@core/utilities/tenant-utilities';
import { LocalStorageService } from '@core/services/local-storage.service';

import { AppBannerComponent } from '@shared/components/app-banner/app-banner.component';


@Component({
  selector: 'app-root',
  imports: [ RouterOutlet, FontAwesomeModule, AppBannerComponent ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('inventory-app');

  private readonly _tenantService = inject(TenantService);
  private readonly _networkStatusService = inject(NetworkStatusService);
  private readonly _localStorage = inject(LocalStorageService);
  
  public tenantUriSafeName = this._tenantService.currentUriTenant;
  public tenantName = this._tenantService.tenantDisplayName;
  public isOnline = this._networkStatusService.isOnline; 
  
  constructor(library: FaIconLibrary) {
    this.applyEarlyDocumentTheme();
    library.addIcons(faBan, faWifi, faCopyright);
  }

  private readThemePreferenceFromLocalStorage(key: string): 'light' | 'dark' | null {
    const v = this._localStorage.get<'light' | 'dark'>(key);
      if (v === 'dark' || v === 'light') {
        return v;
      }
    return null;
  }

  /**
   * Sets `dark-theme` on `<html>` from localStorage before subtree renders.
   * Tenant comes from {@link TenantUtilities.getTenantFromRoute} (same as URL parsing elsewhere).
   */
  private applyEarlyDocumentTheme(): void {
    const tenantId = TenantUtilities.getTenantFromRoute();
    const scopedKey = `theme:${tenantId}`;
    const theme =
      this.readThemePreferenceFromLocalStorage(scopedKey)
    if (theme === 'dark') {
      document.documentElement.setAttribute('dark-theme', '');
    }
  }
}
